'use client';

import { c as _c } from "react/compiler-runtime";
import { exchangeAmountDecimal, type OnrampClient } from '@morfi/onramp-sdk';
import { useExchangeCheckout } from '@morfi/onramp-sdk/react';
import { useLocale, useTranslations } from 'next-intl';
import { type ChangeEvent, type ReactNode, useEffect, useRef, useState } from 'react';
import { AnimatedButton } from '@/components/ui/animated-button';
import { InputField } from '@/components/ui/input-field';
import { logger } from '@/lib/telemetry/logger';
import { useFundingStage } from '../../shared/funding-chrome';
import { useFundingPageActive } from '../../shared/use-funding-page-active';
import { reserveExchangeBrowser } from './funding-exchange-browser';
import { FundingExchangePicker } from './funding-exchange-picker';
import { ExchangeVerification } from './funding-exchange-verification';
export function FundingExchange(t0) {
  const $ = _c(135);
  const {
    client,
    open,
    operationId,
    onBack,
    renderStatus
  } = t0;
  const t = useTranslations("onramp");
  const locale = useLocale();
  const pageActive = useFundingPageActive();
  const t1 = open && pageActive;
  let t2;
  if ($[0] !== operationId) {
    t2 = operationId ? {
      operationId
    } : {};
    $[0] = operationId;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== locale || $[3] !== t1 || $[4] !== t2) {
    t3 = {
      surface: "web",
      locale,
      active: t1,
      ...t2
    };
    $[2] = locale;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    state,
    actions
  } = useExchangeCheckout(client, t3);
  const browser = useRef(null);
  const [browserClosed, setBrowserClosed] = useState(false);
  let t4;
  if ($[6] !== t) {
    t4 = t("exchange_picker_title");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("exchange_connect_title");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t("exchange_balances_title");
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t) {
    t7 = t("exchange_network_title");
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t("exchange_amount_title");
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t) {
    t9 = t("exchange_approve_title");
    $[16] = t;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t) {
    t10 = t("exchange_verification_title");
    $[18] = t;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t) {
    t11 = t("deposit_title");
    $[20] = t;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t10 || $[23] !== t11 || $[24] !== t4 || $[25] !== t5 || $[26] !== t6 || $[27] !== t7 || $[28] !== t8 || $[29] !== t9) {
    t12 = {
      exchanges: t4,
      exchange_auth: t5,
      exchange_balances: t6,
      source: t7,
      amount: t8,
      exchange_approve: t9,
      exchange_2fa: t10,
      status: t11
    };
    $[22] = t10;
    $[23] = t11;
    $[24] = t4;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
    $[28] = t8;
    $[29] = t9;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  const titles = t12 as const;
  let t13;
  if ($[31] !== actions || $[32] !== onBack) {
    t13 = () => {
      if (actions.back() === "methods") {
        browser.current?.close();
        onBack();
      }
    };
    $[31] = actions;
    $[32] = onBack;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  const back = t13;
  useFundingStage(titles[state.screen], false, back, state.screen !== "status");
  let t14;
  if ($[34] !== t) {
    t14 = t("exchange_error_unavailable");
    $[34] = t;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== t) {
    t15 = t("exchange_error_invalid");
    $[36] = t;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== t) {
    t16 = t("exchange_error_insufficient_balance");
    $[38] = t;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  let t17;
  if ($[40] !== t) {
    t17 = t("exchange_error_below_minimum");
    $[40] = t;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== t) {
    t18 = t("exchange_error_review_changed");
    $[42] = t;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== t) {
    t19 = t("exchange_error_verification_rejected");
    $[44] = t;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  let t20;
  if ($[46] !== t) {
    t20 = t("exchange_authorization_expired");
    $[46] = t;
    $[47] = t20;
  } else {
    t20 = $[47];
  }
  let t21;
  if ($[48] !== t14 || $[49] !== t15 || $[50] !== t16 || $[51] !== t17 || $[52] !== t18 || $[53] !== t19 || $[54] !== t20) {
    t21 = {
      unavailable: t14,
      invalid: t15,
      insufficient_balance: t16,
      below_minimum: t17,
      review_changed: t18,
      verification_rejected: t19,
      disconnected: t20
    };
    $[48] = t14;
    $[49] = t15;
    $[50] = t16;
    $[51] = t17;
    $[52] = t18;
    $[53] = t19;
    $[54] = t20;
    $[55] = t21;
  } else {
    t21 = $[55];
  }
  const errors = t21;
  let t22;
  let t23;
  if ($[56] !== state.error || $[57] !== state.operationId || $[58] !== state.screen) {
    t22 = () => {
      if (state.error) {
        logger.warn("onramp.exchange_failed", {
          operationId: state.operationId,
          stage: state.screen,
          code: state.error
        });
      }
    };
    t23 = [state.error, state.operationId, state.screen];
    $[56] = state.error;
    $[57] = state.operationId;
    $[58] = state.screen;
    $[59] = t22;
    $[60] = t23;
  } else {
    t22 = $[59];
    t23 = $[60];
  }
  useEffect(t22, t23);
  let t24;
  let t25;
  if ($[61] !== state.screen) {
    t24 = () => {
      if (state.screen !== "exchange_auth") {
        browser.current?.close();
        return;
      }
      const timer = setInterval(() => setBrowserClosed(browser.current?.closed() ?? false), 500);
      return () => clearInterval(timer);
    };
    t25 = [state.screen];
    $[61] = state.screen;
    $[62] = t24;
    $[63] = t25;
  } else {
    t24 = $[62];
    t25 = $[63];
  }
  useEffect(t24, t25);
  let t26;
  let t27;
  if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = () => () => browser.current?.close();
    t27 = [];
    $[64] = t26;
    $[65] = t27;
  } else {
    t26 = $[64];
    t27 = $[65];
  }
  useEffect(t26, t27);
  let t28;
  if ($[66] !== actions) {
    t28 = function connect() {
      const popup = reserveExchangeBrowser();
      if (!popup) {
        setBrowserClosed(true);
        return;
      }
      browser.current?.close();
      browser.current = popup;
      setBrowserClosed(false);
      actions.connect().then(authorization => {
        if (!authorization || !popup.open(authorization.authorizationUrl)) {
          popup.close();
          setBrowserClosed(true);
        }
      });
    };
    $[66] = actions;
    $[67] = t28;
  } else {
    t28 = $[67];
  }
  const connect = t28;
  if (state.screen === "status" && state.operationId) {
    let t29;
    if ($[68] !== renderStatus || $[69] !== state.operationId) {
      t29 = renderStatus(state.operationId);
      $[68] = renderStatus;
      $[69] = state.operationId;
      $[70] = t29;
    } else {
      t29 = $[70];
    }
    return t29;
  }
  let t29;
  if ($[71] !== errors || $[72] !== state.error) {
    t29 = state.error ? <p role="alert" className="text-body text-foreground-secondary">{errors[state.error]}</p> : null;
    $[71] = errors;
    $[72] = state.error;
    $[73] = t29;
  } else {
    t29 = $[73];
  }
  let t30;
  if ($[74] !== state.status?.status || $[75] !== t) {
    t30 = state.status?.status === "rejected" ? <p className="text-body text-foreground-secondary">{t("exchange_rejected")}</p> : null;
    $[74] = state.status?.status;
    $[75] = t;
    $[76] = t30;
  } else {
    t30 = $[76];
  }
  let t31;
  if ($[77] !== browserClosed || $[78] !== t) {
    t31 = browserClosed ? <output className="text-body text-foreground-secondary">{t("exchange_browser_closed")}</output> : null;
    $[77] = browserClosed;
    $[78] = t;
    $[79] = t31;
  } else {
    t31 = $[79];
  }
  let t32;
  if ($[80] !== connect || $[81] !== state.busy || $[82] !== state.screen) {
    t32 = state.screen === "exchanges" ? <FundingExchangePicker busy={state.busy} onSelect={connect} /> : null;
    $[80] = connect;
    $[81] = state.busy;
    $[82] = state.screen;
    $[83] = t32;
  } else {
    t32 = $[83];
  }
  let t33;
  if ($[84] !== back || $[85] !== connect || $[86] !== state.busy || $[87] !== state.screen || $[88] !== state.status?.status || $[89] !== t) {
    t33 = state.screen === "exchange_auth" ? <div className="flex flex-col gap-3"><p className="text-body text-foreground-secondary">{state.status?.status === "expired" ? t("exchange_authorization_expired") : t("exchange_connect_description")}</p><AnimatedButton loading={state.busy} onClick={connect}>{t("exchange_reopen")}</AnimatedButton><AnimatedButton variant="tertiary" onClick={back}>{t("exchange_cancel")}</AnimatedButton></div> : null;
    $[84] = back;
    $[85] = connect;
    $[86] = state.busy;
    $[87] = state.screen;
    $[88] = state.status?.status;
    $[89] = t;
    $[90] = t33;
  } else {
    t33 = $[90];
  }
  let t34;
  if ($[91] !== actions || $[92] !== state.balances || $[93] !== state.busy || $[94] !== state.screen || $[95] !== t) {
    t34 = state.screen === "exchange_balances" ? <div className="flex flex-col gap-3">{state.balances.length === 0 ? <p className="text-body text-foreground-secondary">{t("exchange_balances_empty")}</p> : state.balances.map(balance => <AnimatedButton key={balance.id} variant="secondary" className="h-auto min-h-16.5 w-full justify-between p-3" onClick={() => actions.selectBalance(balance.id)}><span className="flex flex-col items-start"><span>{balance.name}</span><span className="text-caption text-foreground-secondary">{balance.asset}</span></span></AnimatedButton>)}<AnimatedButton variant="outline" loading={state.busy} onClick={() => {
        actions.refresh();
      }}>{t("retry")}</AnimatedButton></div> : null;
    $[91] = actions;
    $[92] = state.balances;
    $[93] = state.busy;
    $[94] = state.screen;
    $[95] = t;
    $[96] = t34;
  } else {
    t34 = $[96];
  }
  let t35;
  if ($[97] !== actions || $[98] !== state.balance?.routes || $[99] !== state.screen || $[100] !== t) {
    t35 = state.screen === "source" ? <div className="flex flex-col gap-3">{state.balance?.routes.map(route => <AnimatedButton key={route.id} variant="secondary" className="h-auto min-h-16.5 w-full justify-between p-3" onClick={() => actions.selectRoute(route.id)}><span className="flex flex-col items-start"><span>{route.asset} · {route.networkName}</span><span className="text-caption text-foreground-secondary">{t("exchange_balance", {
              amount: exchangeAmountDecimal(route.balanceUnits, route.decimals),
              asset: route.asset
            })}</span></span></AnimatedButton>)}</div> : null;
    $[97] = actions;
    $[98] = state.balance?.routes;
    $[99] = state.screen;
    $[100] = t;
    $[101] = t35;
  } else {
    t35 = $[101];
  }
  let t36;
  if ($[102] !== actions || $[103] !== state.amount || $[104] !== state.busy || $[105] !== state.route || $[106] !== state.screen || $[107] !== t) {
    t36 = state.screen === "amount" && state.route ? <div className="flex flex-col gap-3"><InputField label={state.route.asset} inputMode="decimal" autoComplete="off" value={state.amount} onChange={event => actions.setAmount(event.target.value)} /><p className="text-caption text-foreground-secondary">{t("exchange_balance", {
          amount: exchangeAmountDecimal(state.route.balanceUnits, state.route.decimals),
          asset: state.route.asset
        })}</p><p className="text-caption text-foreground-secondary">{t("exchange_minimum", {
          amount: exchangeAmountDecimal(state.route.minimumUnits, state.route.decimals),
          asset: state.route.asset
        })}</p><AnimatedButton loading={state.busy} onClick={() => {
        actions.prepare();
      }}>{t("exchange_review")}</AnimatedButton></div> : null;
    $[102] = actions;
    $[103] = state.amount;
    $[104] = state.busy;
    $[105] = state.route;
    $[106] = state.screen;
    $[107] = t;
    $[108] = t36;
  } else {
    t36 = $[108];
  }
  let t37;
  if ($[109] !== actions || $[110] !== state.busy || $[111] !== state.review || $[112] !== state.screen || $[113] !== t) {
    t37 = state.screen === "exchange_approve" && state.review ? <div className="flex flex-col gap-3"><p className="text-body text-foreground-secondary">{t("exchange_approve_description")}</p><p className="text-heading-md">{exchangeAmountDecimal(state.review.units, state.review.route.decimals)}{" "}{state.review.route.asset}</p><p className="text-body">{state.review.route.networkName}</p><p className="text-body">{t("exchange_destination")}</p>{state.review.route.feeBps !== null ? <p className="text-caption text-foreground-secondary">{t("estimated_fees")}: {exchangeAmountDecimal(String(state.review.route.feeBps), 2)}%</p> : null}<p className="text-caption text-foreground-secondary">{t("exchange_fees_unknown")}</p><p className="text-caption text-foreground-secondary">{t("exchange_receipt_unknown")}</p><AnimatedButton loading={state.busy} onClick={() => {
        actions.submit();
      }}>{t("exchange_approve")}</AnimatedButton></div> : null;
    $[109] = actions;
    $[110] = state.busy;
    $[111] = state.review;
    $[112] = state.screen;
    $[113] = t;
    $[114] = t37;
  } else {
    t37 = $[114];
  }
  let t38;
  if ($[115] !== actions.confirm || $[116] !== actions.resend || $[117] !== open || $[118] !== pageActive || $[119] !== state.busy || $[120] !== state.screen || $[121] !== state.status?.challenge) {
    t38 = state.screen === "exchange_2fa" ? <ExchangeVerification key={state.status?.challenge?.expiresAt} active={open && pageActive} busy={state.busy} challenge={state.status?.challenge ?? null} onConfirm={actions.confirm} onResend={actions.resend} /> : null;
    $[115] = actions.confirm;
    $[116] = actions.resend;
    $[117] = open;
    $[118] = pageActive;
    $[119] = state.busy;
    $[120] = state.screen;
    $[121] = state.status?.challenge;
    $[122] = t38;
  } else {
    t38 = $[122];
  }
  let t39;
  if ($[123] !== state.busy || $[124] !== t29 || $[125] !== t30 || $[126] !== t31 || $[127] !== t32 || $[128] !== t33 || $[129] !== t34 || $[130] !== t35 || $[131] !== t36 || $[132] !== t37 || $[133] !== t38) {
    t39 = <div className="rr-block flex flex-col gap-4" aria-busy={state.busy}>{t29}{t30}{t31}{t32}{t33}{t34}{t35}{t36}{t37}{t38}</div>;
    $[123] = state.busy;
    $[124] = t29;
    $[125] = t30;
    $[126] = t31;
    $[127] = t32;
    $[128] = t33;
    $[129] = t34;
    $[130] = t35;
    $[131] = t36;
    $[132] = t37;
    $[133] = t38;
    $[134] = t39;
  } else {
    t39 = $[134];
  }
  return t39;
}